export default "__VITE_ASSET__DnkDMJcN__"